<script setup lang="ts">
defineProps<{
  data: PeopleProps
  template?: 'page' | 'overlay'
}>()
</script>
<template>
  <section
    class="px-bleed"
    :class="{
      'bg-white': template !== 'page' && template !== 'overlay' && data.theme !== 'light-grey',
      'bg-light-grey':
        template === 'page' || (template !== 'overlay' && data.theme === 'light-grey'),
    }"
  >
    <ul class="gap-gap grid grid-cols-2 gap-y-10 lg:grid-cols-4">
      <li v-for="(person, idx) in data.people" :key="idx">
        <CommonMedia
          :sizes="['33vw', '50vw']"
          :aspect="data.crop ? 4 / 5 : undefined"
          :fill="'w'"
          class="mb-4"
          :media="person.media"
        />

        <p class="font-display mb-3 text-xl uppercase font-stretch-expanded">{{ person.title }}</p>

        <div class="flex flex-col gap-1">
          <span>{{ person.position }}</span>
          <span>{{ person.email }}</span>
          <span>{{ person.phone }}</span>
        </div>
      </li>
    </ul>
  </section>
</template>
